import { c as _c } from "react/compiler-runtime";
import { SkeletonPropertiesType } from "@website/ui/skeleton/skeleton.types";
import { FC } from "react";
const SHAPE_CLASSES = {
  circle: "rounded-full",
  square: "rounded-[4px]",
  rectangle: "rounded-[4px]"
} as const;
export const Skeleton: FC<SkeletonPropertiesType> = t0 => {
  const $ = _c(7);
  const {
    className,
    shape: t1,
    height,
    width,
    margin
  } = t0;
  const shape = t1 === undefined ? "rectangle" : t1;
  const shapeClass = SHAPE_CLASSES[shape] || SHAPE_CLASSES.rectangle;
  const isSquareOrCircle = shape === "circle" || shape === "square";
  const t2 = `bg-outline-thin relative w-full animate-pulse overflow-hidden ${shapeClass} ${className}`;
  const t3 = height ? `${height}px` : "100%";
  const t4 = isSquareOrCircle ? `${height}px` : width ?? "100%";
  let t5;
  if ($[0] !== margin || $[1] !== t3 || $[2] !== t4) {
    t5 = {
      height: t3,
      width: t4,
      margin
    };
    $[0] = margin;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t2 || $[5] !== t5) {
    t6 = <div className={t2} style={t5} />;
    $[4] = t2;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};